export default class KultuNaut {
  boot () {
    window.addEventListener('load', this.init.bind(this))
  }

  init () {
    /* If KultuNaut has not initialised by itself, we will manually do it */
    if (typeof window.naut !== 'undefined') {
      window.naut.init()
    }
  }
}
